import { useTranslation } from "react-i18next";
import {
  isAfterDate,
  isBeforeDate,
  isDateBetween,
} from "../../../../util/format";

interface useStatusTurmaProps {
  dataInicio: Date;
  dataFim: Date;
}

export default function useStatusTurma({
  dataInicio,
  dataFim,
}: useStatusTurmaProps) {
   const { t } = useTranslation(['gestao_de_aulas']);
  let dotColor = "";
  let statusText = "";

  if (isBeforeDate(dataInicio)) {
    dotColor = 'dot-orange';
    statusText = t('gestao_de_aulas:notStarted');
  }

  if (isDateBetween(dataInicio, dataFim)) {
    dotColor = 'dot-green';
    statusText = t('gestao_de_aulas:inProgress');
  }

  if (isAfterDate(dataFim)) {
    dotColor = 'dot-orange';
    statusText = t('gestao_de_aulas:finished');
  }

  return {
    dotColor,
    statusText,
  };
}
